import { createFileRoute } from '@tanstack/react-router';

import { I18nBreadcrumb } from '@/components/ui/i18breadcrumb';
import { ensureEstateQueryData } from '@/features/estates-property/api/estate';
import { EstateAnalyticsDashboard } from '@/pages/estates-analytics';

export const Route = createFileRoute(
  '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/analytics'
)({
  component: EstateAnalyticsDashboard,
  loader: ensureEstateQueryData,
  staticData: { breadcrumb: () => <I18nBreadcrumb translationKey="estate-analytics" /> },
});
